import React, { useState, useEffect } from 'react';
import { Button, Box } from '@mui/material';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useSelector } from 'react-redux';
import Label from '@/components/form/Label/Label';
import './GuestSelectedView.scss';

const SearchBar = props => {
  const { languageData, onBack, showForm } = props;

  const getBackText = () => {
    if (showForm) {
      return languageData === 'EN'
        ? 'Back to guest details'
        : 'Volver al detalle del asistente';
    }
    return languageData === 'EN'
      ? 'Back to booking details'
      : 'Volver al detalle de la reserva';
  };

  return (
    <FlexContainer className={'SearchBar align-items-end'}>
      <i className="fa fa-chevron-left" onClick={onBack}></i>
      <Label
        className={'fontWhite text-12 margl10 cursor-pointer'}
        onClick={onBack}
      >
        {getBackText()}
      </Label>
    </FlexContainer>
  );
};

const GuestForm = props => {
  const { onSubmit, onBack, loading, error, languageData, initialValues } =
    props;

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
  });

  const [focusedFields, setFocusedFields] = useState({
    firstName: false,
    lastName: false,
    email: false,
  });

  useEffect(() => {
    if (initialValues) {
      setFormData({
        firstName: initialValues.firstName || '',
        lastName: initialValues.lastName || '',
        email: initialValues.email || '',
      });

      setFocusedFields({
        firstName: !!initialValues.firstName,
        lastName: !!initialValues.lastName,
        email: !!initialValues.email,
      });
    }
  }, [initialValues]);

  const handleSubmit = e => {
    e.preventDefault();
    if (
      !formData.firstName.trim() ||
      !formData.lastName.trim() ||
      !formData.email.trim()
    )
      return;
    onSubmit(formData);
  };

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFocus = fieldName => {
    setFocusedFields(prev => ({
      ...prev,
      [fieldName]: true,
    }));
  };

  const handleBlur = fieldName => {
    setFocusedFields(prev => ({
      ...prev,
      [fieldName]: false,
    }));
  };

  const shouldFloat = fieldName => {
    return formData[fieldName].trim() !== '' || focusedFields[fieldName];
  };

  return (
    <FlexContainer className="GuestSelectedView flex-column padlr10 justify-start items-center bgGradientBlue fontWhite">
      <SearchBar languageData={languageData} onBack={onBack} showForm={true} />

      <FlexContainer
        className={
          'flex-column width100 height-550px boxSizing_borderBox padtb0 padlr20'
        }
      >
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          {error && (
            <Label className="text-14 margt10" style={{ color: '#ff4444' }}>
              {error}
            </Label>
          )}

          <Box className="margt20 margb10 width100 pos-rel">
            <Label
              className="text-14 pos-abs left0 pointerEventsNone"
              style={{
                top: shouldFloat('firstName') ? '0px' : '18px',
                fontSize: shouldFloat('firstName') ? '10px' : '12px',
                color: shouldFloat('firstName')
                  ? 'rgba(255,255,255,0.6)'
                  : 'rgba(255,255,255,0.8)',
                transition: 'all 0.2s ease',
                zIndex: 1,
              }}
            >
              {languageData === 'EN' ? 'First Name' : 'Nombre'}
            </Label>
            <FlexContainer className="pos-rel width100">
              <input
                name="firstName"
                type="text"
                value={formData.firstName}
                onChange={handleChange}
                onFocus={() => handleFocus('firstName')}
                onBlur={() => handleBlur('firstName')}
                className="borderTopNone borderLeftNone borderRightNone borderBottomLine borderImage borderBottomLine margTop5 borderrad0 text-16 fontWhite width100 bgTransparent boxSizing_borderBox outlineNone"
                style={{
                  padding: shouldFloat('firstName')
                    ? '20px 60px 8px 0px'
                    : '8px 60px 8px 0px',
                  transition: 'all 0.2s ease',
                }}
              />

              {!formData.firstName.trim() && (
                <Label
                  className="text-10 pos-abs right0 pointerEventsNone top18"
                  style={{ color: 'rgba(255,255,255,0.6)' }}
                >
                  {languageData === 'EN' ? 'Required' : 'Requerido'}
                </Label>
              )}
            </FlexContainer>
          </Box>

          <Box className="margt10 margb10 width100 pos-rel">
            <Label
              className="text-14 fontWhite pos-abs left0 pointerEventsNone"
              style={{
                top: shouldFloat('lastName') ? '0px' : '18px',
                fontSize: shouldFloat('lastName') ? '10px' : '12px',
                color: shouldFloat('lastName')
                  ? 'rgba(255,255,255,0.6)'
                  : 'rgba(255,255,255,0.8)',
                transition: 'all 0.2s ease',
                zIndex: 1,
              }}
            >
              {languageData === 'EN' ? 'Last Name' : 'Apellido'}
            </Label>
            <FlexContainer className="pos-rel width100">
              <input
                name="lastName"
                type="text"
                value={formData.lastName}
                onChange={handleChange}
                onFocus={() => handleFocus('lastName')}
                onBlur={() => handleBlur('lastName')}
                className="borderTopNone borderLeftNone borderRightNone borderBottomLine borderImage borderBottomLine margTop5 borderrad0 text-16 fontWhite width100 bgTransparent boxSizing_borderBox outlineNone"
                style={{
                  padding: shouldFloat('lastName')
                    ? '20px 60px 8px 0px'
                    : '8px 60px 8px 0px',
                  transition: 'all 0.2s ease',
                }}
              />

              {!formData.lastName.trim() && (
                <Label
                  className="text-10 pos-abs right0 pointerEventsNone top18"
                  style={{ color: 'rgba(255,255,255,0.6)' }}
                >
                  {languageData === 'EN' ? 'Required' : 'Requerido'}
                </Label>
              )}
            </FlexContainer>
          </Box>

          <Box className="margt10 margb10 width100 pos-rel">
            <Label
              className="text-14 fontWhite pos-abs left0 pointerEventsNone"
              style={{
                top: shouldFloat('email') ? '0px' : '18px',
                fontSize: shouldFloat('email') ? '10px' : '12px',
                color: shouldFloat('email')
                  ? 'rgba(255,255,255,0.6)'
                  : 'rgba(255,255,255,0.8)',
                transition: 'all 0.2s ease',
                zIndex: 1,
              }}
            >
              {languageData === 'EN' ? 'Email' : 'Correo Electrónico'}
            </Label>
            <FlexContainer className="pos-rel width100">
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                onFocus={() => handleFocus('email')}
                onBlur={() => handleBlur('email')}
                className="borderTopNone borderLeftNone borderRightNone borderBottomLine borderImage borderBottomLine margTop5 borderrad0 text-16 fontWhite width100 bgTransparent boxSizing_borderBox outlineNone"
                style={{
                  padding: shouldFloat('email')
                    ? '20px 60px 8px 0px'
                    : '8px 60px 8px 0px',
                  transition: 'all 0.2s ease',
                }}
              />

              {!formData.email.trim() && (
                <Label
                  className="text-10 pos-abs right0 pointerEventsNone top18"
                  style={{ color: 'rgba(255,255,255,0.6)' }}
                >
                  {languageData === 'EN' ? 'Required' : 'Requerido'}
                </Label>
              )}
            </FlexContainer>

            <Label
              className="text-14 margt10 lineHeight-1-4"
              style={{ color: 'rgba(255,255,255,0.6)' }}
            >
              {languageData === 'EN'
                ? 'If you provide an email, the guest will receive a copy of the receipt.'
                : 'Si proporcionas un email, el asistente recibirá una copia del recibo.'}
            </Label>
          </Box>

          <FlexContainer className="flex-column margt30 width100">
            <Button
              className={'bgGradientSignUpPurple'}
              type="submit"
              fullWidth
              sx={{
                py: 1.2,
                color: 'white',
                borderRadius: '10px',
                textTransform: 'none',
                fontSize: '12px',
                marginTop: '20px',
                '&:disabled': { opacity: 0.7 },
              }}
              disabled={
                loading ||
                !formData.firstName ||
                !formData.lastName ||
                !formData.email
              }
            >
              {loading
                ? languageData === 'EN'
                  ? 'Loading...'
                  : 'Cargando...'
                : languageData === 'EN'
                  ? 'Save'
                  : 'Guardar'}
            </Button>
          </FlexContainer>
        </form>
      </FlexContainer>
    </FlexContainer>
  );
};

const GuestListView = props => {
  const {
    guests,
    onSelectGuest,
    onAddGuest,
    onBack,
    loading,
    error,
    languageData,
    selectedCount,
  } = props;

  return (
    <FlexContainer className="GuestSelectedView flex-column padlr10 justify-start items-center bgGradientBlue fontWhite">
      <SearchBar languageData={languageData} onBack={onBack} showForm={false} />

      <FlexContainer className={'flex-column padlr20 height-550px'}>
        <Label className={'text-18 margt20'}>
          {languageData === 'EN'
            ? 'Select One Guest'
            : 'Selecciona un Asistente'}
        </Label>
        <Label
          className={'text-14 margtb10'}
          style={{ color: 'rgba(255,255,255,0.4)' }}
        >
          {languageData === 'EN'
            ? 'Choose someone else to replace your name on the booking. A valid ID and credit card are required at check-in.'
            : 'Elige a alguien más para reemplazar tu nombre en la reserva. Se requiere una identificación válida y tarjeta de crédito en el check-in.'}
        </Label>
        <Label
          className={'text-14 margtb10'}
          style={{ color: 'rgba(255,255,255,0.4)' }}
        >
          {languageData === 'EN'
            ? 'If you provide an email, the guest will receive a copy of the receipt.'
            : 'Si proporcionas un email, el asistente recibirá una copia del recibo.'}
        </Label>

        {error && (
          <Label className="text-14 margt10" style={{ color: '#ff4444' }}>
            {error}
          </Label>
        )}

        <FlexContainer className="align-items-center margt20">
          <Label className={'text-16'}>
            <strong>
              {languageData === 'EN' ? 'Guest Names' : 'Nombres de Asistentes'}
            </strong>
          </Label>
          <Label
            className="text-12 margl10"
            style={{ color: 'rgba(255,255,255,0.6)' }}
          >
            ({selectedCount || 0}{' '}
            {languageData === 'EN' ? 'selected' : 'seleccionados'})
          </Label>
        </FlexContainer>

        {guests.map(guest => (
          <Box key={guest.id} className="width100 margt10">
            <FlexContainer className="align-items-center justify-between width100">
              <Label
                className="text-14 fontWhite cursor-pointer"
                onClick={() => onSelectGuest(guest)}
                style={{ fontWeight: guest.isSelected ? 'bold' : 'normal' }}
              >
                {guest.firstName} {guest.lastName}{' '}
                {guest.isDefault && (
                  <span style={{ color: 'rgba(255,255,255,0.4)' }}>
                    {languageData === 'EN' ? '(Default)' : '(Por defecto)'}
                  </span>
                )}
              </Label>

              <i
                className={`fontWhite cursor-pointer ${
                  guest.isSelected
                    ? 'fa-solid fa-circle-check'
                    : 'fa-regular fa-circle'
                }`}
                style={{
                  fontSize: '16px',
                  opacity: guest.isSelected ? 1 : 0.5,
                  transition: 'all 0.2s ease',
                }}
                onClick={() => onSelectGuest(guest)}
              ></i>
            </FlexContainer>

            {guest.email && (
              <Label
                className={'text-14 margtb10'}
                style={{ color: 'rgba(255,255,255,0.4)' }}
              >
                {guest.email}
              </Label>
            )}

            <FlexContainer className="width100">
              <Label
                className="width100 height-1px"
                style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}
              />
            </FlexContainer>
          </Box>
        ))}

        <FlexContainer className={'flex-column margt20 margb90 padlr20'}>
          <button
            className={'fontWhite text-16 padtb10 bgTransparent borderGray5'}
            onClick={onAddGuest}
            disabled={loading}
          >
            {languageData === 'EN'
              ? 'Enter a Different Guest'
              : 'Ingresar un Asistente Diferente'}
          </button>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

const GuestSelectedView = props => {
  const {
    showForm,
    guests,
    selectedCount,
    onSelectGuest,
    onAddGuest,
    onBack,
    onSubmitForm,
    loading,
    error,
    languageData,
    initialFormValues,
  } = props;

  if (showForm) {
    return (
      <GuestForm
        onSubmit={onSubmitForm}
        onBack={onBack}
        loading={loading}
        error={error}
        languageData={languageData}
        initialValues={initialFormValues}
      />
    );
  }

  return (
    <GuestListView
      guests={guests}
      selectedCount={selectedCount}
      onSelectGuest={onSelectGuest}
      onAddGuest={onAddGuest}
      onBack={onBack}
      loading={loading}
      error={error}
      languageData={languageData}
    />
  );
};

export default GuestSelectedView;
